import React, { SVGProps } from 'react';

const SvgChevronUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={props.color || 'currentColor'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.5 16 12 8.5l7.5 7.5"
    />
  </svg>
);
SvgChevronUpIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgChevronUpIcon;
